import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '@/utils/analytics';

/**
 * Maps route paths to page titles for analytics tracking
 * Supports dynamic segments with :param syntax
 */
const getPageTitle = (pathname) => {
    // Define route-to-title mappings
    const routeTitles = {
        '/': 'Home',
        '/login': 'Login',
        '/dashboard': 'Dashboard',
        '/dashboard/quotes': 'Quotes',
        '/dashboard/quotes/create': 'Create Quote',
        '/dashboard/policies': 'Policies',
        '/dashboard/settings': 'Settings',
        '/dashboard/users': 'Users',
        '/dashboard/agencies': 'Agencies',
    };

    // Check for exact match first
    if (routeTitles[pathname]) {
        return routeTitles[pathname];
    }

    // Handle dynamic routes with parameters
    if (pathname.match(/^\/dashboard\/quotes\/view\/comp\/.+$/)) {
        return 'View Quote';
    }
    if (pathname.match(/^\/dashboard\/quotes\/view\/bop\/.+$/)) {
        return 'View Quote';
    }
    if (pathname.match(/^\/dashboard\/policies\/view\/comp\/.+$/)) {
        return 'View Policy';
    }
    if (pathname.match(/^\/dashboard\/policies\/view\/bop\/.+$/)) {
        return 'View Policy';
    }

    // Handle indexed routes (e.g., /dashboard/quotes/0)
    if (pathname.match(/^\/dashboard\/quotes\/\d+$/)) {
        return 'Quotes';
    }
    if (pathname.match(/^\/dashboard\/policies\/\d+$/)) {
        return 'Policies';
    }

    // Default fallback
    return 'DigiQuote';
};

/**
 * Custom hook to track page views and update document title
 * Call this once in App.jsx to track all route changes
 */
const usePageTracking = () => {
    const location = useLocation();

    useEffect(() => {
        const pageTitle = getPageTitle(location.pathname);
        const fullTitle = pageTitle === 'DigiQuote' ? 'DigiQuote' : `${pageTitle} - DigiQuote`;

        // Update browser tab title
        document.title = fullTitle;

        // Send page view to Google Analytics
        trackPageView(fullTitle, location.pathname);
    }, [location.pathname]);
};

export default usePageTracking;
